module.exports = __webpack_public_path__ + "img/helichrysum-sanguineum.46969377.jpg";